import {
  Center,
  Flex,
  Icon,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import { AiOutlineCode } from "react-icons/ai";
import { IoMenuSharp } from "react-icons/io5";
import { IoIosClose } from "react-icons/io";
import { MdOutlineLastPage } from "react-icons/md";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-scroll";

export default function Navbar() {
  const [isHovered, setIsHovered] = useState(false);
  const nav = useNavigate();

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  return (
    <Flex
      width={"100%"}
      borderBottom={"1.5px solid black"}
      justifyContent={"space-between"}
      alignItems={"center"}
      padding={"32px 0"}
    >
      <Flex>
        <Center>
          <Icon fontSize={"5xl"} as={AiOutlineCode}></Icon>
        </Center>

        <Flex
          alignItems={"center"}
          className="font-title"
          fontSize={{ base: "lg", md: "2xl", lg: "3xl" }}
        >
          Samdipro Nainggolan
        </Flex>
      </Flex>
      <Flex gap={"1rem"} className="font-mono">
        <Flex
          gap={"1.4rem"}
          alignItems={"center"}
          display={{ base: "none", md: "flex" }}
        >
          <Link to="home" smooth={true} duration={500}>
            <Flex
              cursor={"pointer"}
              _hover={{ borderBottom: "2px solid black" }}
              borderBottom={"2px solid transparent"}
            >
              HOME
            </Flex>
          </Link>
          <Link to="stack" smooth={true} duration={500}>
            <Flex
              cursor={"pointer"}
              _hover={{ borderBottom: "2px solid black" }}
              borderBottom={"2px solid transparent"}
            >
              STACK
            </Flex>
          </Link>

          <Link to="profile" smooth={true} duration={500}>
            <Flex
              cursor={"pointer"}
              _hover={{ borderBottom: "2px solid black" }}
              borderBottom={"2px solid transparent"}
            >
              PROFILE
            </Flex>
          </Link>

          <Flex
            borderRadius={"0.4rem"}
            padding={"0.5rem"}
            bgColor={"black"}
            color={"white"}
            cursor={"pointer"}
            alignItems={"center"}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            gap={"0.3rem"}
            _hover={{ fontSize: "sm", transition: "0.3s" }}
            height={"2.5rem"}
            width={"7rem"}
            justifyContent={"center"}
            onClick={() => nav("/port")}
          >
            <Text>PORTFOLIO</Text>
            {isHovered ? <Icon as={MdOutlineLastPage}></Icon> : null}
          </Flex>
        </Flex>
        <Flex alignItems={"center"} display={{ base: "flex", md: "none" }}>
          <Menu>
            {({ isOpen }) => (
              <>
                <MenuButton
                  isActive={isOpen}
                  _hover={{
                    bgColor: "black",
                    color: "white",
                  }}
                  borderRadius={"50%"}
                >
                  {isOpen ? (
                    <Center
                      borderRadius={"50%"}
                      width={"2.5rem"}
                      height={"2.5rem"}
                      border={"2px solid black"}
                      cursor={"pointer"}
                    >
                      <Icon fontSize={"1.5rem"} as={IoIosClose}></Icon>
                    </Center>
                  ) : (
                    <Center
                      borderRadius={"50%"}
                      width={"2.5rem"}
                      height={"2.5rem"}
                      border={"2px solid black"}
                      cursor={"pointer"}
                    >
                      <Icon as={IoMenuSharp}></Icon>
                    </Center>
                  )}
                </MenuButton>

                <MenuList bgColor={"#fdfbf5"} padding={"1rem"}>
                  <Link
                    bgColor={"#fdfbf5"}
                    to="home"
                    smooth={true}
                    duration={500}
                  >
                    <Flex _hover={{ bgColor: "white" }}>Home</Flex>
                  </Link>

                  <Link
                    bgColor={"#fdfbf5"}
                    to="stack"
                    smooth={true}
                    duration={500}
                  >
                    <Flex _hover={{ bgColor: "white" }}>Stack</Flex>
                  </Link>

                  <Link
                    bgColor={"#fdfbf5"}
                    to="profile"
                    smooth={true}
                    duration={500}
                  >
                    <Flex _hover={{ bgColor: "white" }}>Profile</Flex>
                  </Link>

                  <MenuItem
                    bgColor={"#fdfbf5"}
                    fontWeight={"bold"}
                    _hover={{ bgColor: "white" }}
                    onClick={() => nav("/port")}
                  >
                    Portfolio
                    <Icon as={MdOutlineLastPage}></Icon>
                  </MenuItem>
                </MenuList>
              </>
            )}
          </Menu>
        </Flex>
      </Flex>
    </Flex>
  );
}
